import React from 'react';
import PropTypes from 'prop-types';
import TextSkeleton from 'components/text-skeleton';
import cn from 'classnames';

const LoadMoreButton = ({
  text,
  asSkeleton,
  onClick = () => {},
  className,
}) => {
  const handleClick = () => {
    onClick();
  };

  return (
    <button
      onClick={handleClick}
      className={cn('load-more-button', className, {
        'load-more-button_skeleton': asSkeleton,
      })}
    >
      <span className="load-more-button__text">{text}</span>
      {asSkeleton && (
        <TextSkeleton
          className="load-more-button__text-skeleton"
          maxLines={1}
        />
      )}
    </button>
  );
};

LoadMoreButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  asSkeleton: PropTypes.bool,
  className: PropTypes.string,
};

LoadMoreButton.viewModelMeta = 'ignore';

export default LoadMoreButton;
